import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueAnalytics from 'vue-analytics';
// import axios from 'axios'
// Vue.use(axios)

import VueTypedJs from 'vue-typed-js'
Vue.use(VueTypedJs)

// no tips
Vue.config.productionTip = false;

// Analytics
Vue.use(VueAnalytics, {
    id: 'UA-75833214-1',
    router
});

import VueToast from 'vue-toast-notification'
// import 'vue-toast-notification/dist/theme-default.css'
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast, {
  duration: 2000,
  position: "bottom-left"
})

import es from 'vee-validate/dist/locale/es'
import VeeValidate, { Validator } from "vee-validate";
Vue.use(VeeValidate);
Validator.localize("es", es);

// service worker
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/iuri.is-sw.js').then(registration => {
            //console.log('SW registered: ', registration);
        }).catch(registrationError => {
            //console.log('SW registration failed: ', registrationError);
        });
    });
}

// instance
new Vue({
    router,
    render: h => h(App),
}).$mount('#app');
